<template>
  <auth-page>
    <div slot="content">
      <h1 class="title is-3 has-text-centered">Registreren</h1>
      <div class="columns social-buttons is-marginless">
        <div class="column">
          <button class="button is-fullwidth" @click="loginWithSocial('google')" expanded>
            <img class="mr-2 social-icon" src="@/assets/google-logo.svg" />
            Google
          </button>
        </div>
        <div class="column">
          <button class="button is-fullwidth" @click="loginWithSocial('discord')" expanded>
            <img class="mr-2 social-icon" src="@/assets/discord-logo.svg" />
            Discord
          </button>
        </div>
      </div>
      <hr />
      <div class="form">
        <b-tabs expanded type="is-boxed" v-model="activeTab">
          <b-tab-item label="Scholier">
            <form class="mt-4" @keydown.enter="register()">
              <validation-provider class="validation-field" name="Gebruikersnaam" rules="required|alpha|min:6|max:20" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Gebruikersnaam">
                    <b-input v-model="user.username"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
              <validation-provider class="validation-field" name="Wachtwoord" rules="required|min:6" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Wachtwoord">
                    <b-input has-counter type="password" v-model="user.password"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
              <validation-provider class="validation-field" name="Email" rules="required|email" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Email adres">
                    <b-input v-model="user.email"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field high-field">
                    <b-field label="Leerjaar">
                      <b-select size="is-medium" v-model="user.year" placeholder="Selecteer je jaar" expanded>
                        <option v-for="n in 10" :value="n" :key="n">{{ n }}</option>
                        <option value="anders">Anders</option>
                      </b-select>
                    </b-field>
                  </div>
                  <div class="field high-field">
                    <b-field label="Opleiding">
                      <b-select size="is-medium" v-model="user.level" placeholder="Selecteer je opleiding" expanded>
                        <option v-for="level in educationLevels" :value="level" :key="level">{{ level | capitalize }}</option>
                        <option value="anders">Anders</option>
                      </b-select>
                    </b-field>
                  </div>
                </div>
              </div>
            </form>
          </b-tab-item>
          <b-tab-item label="Docent">
            <form class="mt-4" @keydown.enter="register()">
              <validation-provider class="validation-field" name="Gebruikersnaam" rules="required|alpha|min:6|max:20" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Gebruikersnaam">
                    <b-input v-model="user.username"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
              <validation-provider class="validation-field" name="Wachtwoord" rules="required" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Wachtwoord">
                    <b-input has-counter type="password" v-model="user.password"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
              <validation-provider class="validation-field" name="Email" rules="required|email" v-slot="{ errors }">
                <div class="high-field">
                  <b-field label="Email adres">
                    <b-input v-model="user.email"></b-input>
                  </b-field>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </div>
              </validation-provider>
            </form>
          </b-tab-item>
        </b-tabs>
        <small>Ik ga akkoord met de <router-link to="/av.pdf" target="_blank">Algemene voorwaarden</router-link></small>
        <b-button class="mt-4" type="is-info" expanded @click.native="register()">Account maken</b-button>
        <div class="block has-text-centered mt-2">
          <router-link class="color-dark grayed-out" to="/login">Ik heb al een account</router-link>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </auth-page>
</template>

<script>
import AuthPage from "../components/AuthPage.vue"
import Joi from "joi-browser"
import { USER_REGISTER, USER_LOGOUT } from "@/store/User/action.type"

export default {
  components: { AuthPage },
  name: "Register",
  data() {
    return {
      activeTab: 0,
      user: {
        username: "",
        password: "",
        email: "",
        year: 1,
        level: "havo",
        role: "student",
        refferal: "",
      },
    }
  },
  methods: {
    async loginWithSocial(social) {
      this.$buefy.loading.open
      window.location.href = process.env.VUE_APP_API + "/auth/" + social
    },
    async register() {
      if (!this.isFormValid()) {
        return this.$buefy.toast.open({
          message: "Het formulier is niet compleet of correct",
          type: "is-danger",
        })
      }

      if ($cookies.get("refferal")) {
        this.user.refferal = $cookies.get("refferal")
      }

      if (this.activeTab === 1) {
        this.user.role = "teacher"
      }

      if (this.activeTab === 2) {
        this.user.role = "parent"
      }

      let response = await this.$store.dispatch(USER_REGISTER, this.user)
      if (response.status == 400) {
        return this.$buefy.toast.open({
          message: response.data.message,
          type: "is-danger",
        })
      }
      this.$buefy.toast.open({
        message: "Welkom!",
        type: "is-success",
      })

      this.$gtag.event("register", { event_category: "user", value: 1 })
      window.fbq("track", "CompleteRegistration")

      //Only record conversion if user came via google ads
      if (this.user.refferal == "ga") gtag("event", "conversion", { send_to: "AW-974458431/KENQCOfJ3s4BEL-c1NAD" })

      window.location.href = process.env.VUE_APP_WORDS + "/welcome"
    },
    isFormValid() {
      let schema = {
        username: Joi.string().min(6).required(),
        password: Joi.string().min(6).required(),
        email: Joi.string().email({ minDomainSegments: 2 }),
        year: Joi.any().valid(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "anders").required(),
        level: Joi.string().min(2).required(),
        role: Joi.string().min(2).required(),
        refferal: Joi.string().allow("").allow(null),
      }
      return Joi.validate(this.user, schema).error === null
    },
  },
  computed: {
    educationLevels() {
      return this.$store.state.app.educationLevels
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ""
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>

<style lang="scss" scoped>
.social-icon {
  max-height: 15px;
}
.social-buttons {
  .column {
    padding: 5px 5px 0 5px;
    @media only screen and (min-width: 769px) {
      &:first-child {
        padding-left: 0 !important;
      }
      &:last-child {
        padding-right: 0 !important;
      }
    }
  }
}
</style>
